import React, { Fragment, useCallback, useEffect, useState } from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import {
  useGetContactDetailsQuery,
  useGetPageDataQuery,
  useSubmitContactMutation,
} from "../Store/api/CommonApi";
import { error, success } from "../Services/CommonService";

export default function Contact() {
  const [contact, setContact] = useState({});
  const { data } = useGetPageDataQuery("contact-us");
  const contactApi = useGetContactDetailsQuery();
  const [submitContact] = useSubmitContactMutation();

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const formData = new FormData(e.target);
      let data = Object.fromEntries(formData);
      submitContact(data)
        .then((res) => {
          if (res.data?.code === "success") {
            e.target.reset();
            success(res.data?.message);
          } else {
            error("Request not submission failed.");
          }
        })
        .catch((err) => console.log(err));
    },
    [submitContact]
  );

  useEffect(() => {
    if (contactApi?.data?.data) {
      setContact(contactApi?.data?.data);
    }
  }, [contactApi?.data, setContact]);

  return (
    <Fragment>
      <PageBannerComponent
        title={data?.data?.heading}
        image={data?.data?.image}
      />

      {data?.data?.content !== "" && (
        <div className="container mt-4">
          <p dangerouslySetInnerHTML={{ __html: data?.data?.content }}></p>
        </div>
      )}

      {/* Start contact-page Area */}
      {data?.content !== "" && (
        <div className="container">
          <p dangerouslySetInnerHTML={{ __html: data?.content }}></p>
        </div>
      )}
      <section className="contact-page-area section-gap">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="contact-box">
                <i className="fa fa-map-marker" />
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      contact?.address ??
                      "Pride Circle Unit of Inclusion First Consultancy Pvt Ltd 513, Rupa Solitaire, Millennium Business Park, Mahape, Ghansoli, Navi Mumbai, Maharashtra - 400710",
                  }}
                >
                  {/* Pride Circle Unit of
                  <br />
                  Inclusion First Consultancy Pvt Ltd
                  <br />
                  513, Rupa Solitaire, Millennium Business
                  <br />
                  Park, Mahape, Ghansoli,
                  <br />
                  Navi Mumbai, Maharashtra - 400710 */}
                  {/* {contact?.address ??
                    "Pride Circle Unit of Inclusion First Consultancy Pvt Ltd 513, Rupa Solitaire, Millennium Business Park, Mahape, Ghansoli, Navi Mumbai, Maharashtra - 400710"} */}
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="contact-box">
                <i className="fa fa-envelope" />
                <p>{contact?.to_email ?? "Contact@thepridecircle.com"}</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="contact-box">
                <i className="fa fa-phone" />
                <p>{contact?.phone_no ?? "+91 7047 7047 90"}</p>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="section-gap row">
              <div className="col-md-6 col-sm-6 pb-15">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  className="single-input"
                />
              </div>
              <div className="col-md-6 col-sm-6 pb-15">
                <input
                  type="email"
                  name="email"
                  placeholder="Email address"
                  //onfocus="this.placeholder = ''"
                  //onblur="this.placeholder = 'Email address'"
                  required
                  className="single-input"
                />
              </div>
              <div className="col-md-6 col-sm-6 pb-15">
                <input
                  type="number"
                  name="phone_no"
                  placeholder="Phone Number"
                  //onfocus="this.placeholder = ''"
                  //onblur="this.placeholder = 'Phone Number'"
                  required
                  className="single-input"
                />
              </div>
              <div className="col-md-6 col-sm-6 pb-15">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  //onfocus="this.placeholder = ''"
                  //onblur="this.placeholder = 'Subject'"
                  required
                  className="single-input"
                />
              </div>
              <div className="col-md-12 col-sm-12 pb-30">
                <textarea
                  name="message"
                  className="single-textarea"
                  placeholder="Message"
                  //onfocus="this.placeholder = ''"
                  //onblur="this.placeholder = 'Message'"
                  required
                />
              </div>
              <div className="col-md-12 col-sm-12">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>
      {/* End contact-page Area */}
    </Fragment>
  );
}
